import clsx from 'clsx'
import {compact, get} from 'lodash'
import React from 'react'

type Props = {
  className?: string
  name?: string
  data: any
  fullnameClassName?: string
}

const ShowAddress: React.FC<Props> = ({
  name = '',
  data,
  className = '',
  fullnameClassName = 'fs-7',
}) => {
  const prefix = name ? `${name}_` : ''
  const firstName = get(data, `${prefix}first_name`, '')
  const lastName = get(data, `${prefix}last_name`, '')
  const company = get(data, `${prefix}company`, '')
  const street1 = get(data, `${prefix}street1`, '')
  const city = get(data, `${prefix}city`, '')
  const state = get(data, `${prefix}state`, '')
  const zip = get(data, `${prefix}zip`, '')

  const fullName = compact([firstName, lastName]).join(' ')
  const address = compact([street1, city, state, zip]).join(' ')

  return (
    <div className={clsx(className)}>
      {company && <div className='fw-bolder'>{company}</div>}
      {fullName && <div className={fullnameClassName}>{fullName}</div>}
      {address && <div className='d-block mt-2'>{address}</div>}
    </div>
  )
}

export {ShowAddress}
